"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicEmbed = void 0;
var tslib_1 = require("tslib");
var public_catalog_service_1 = require("../../../catalog-services/public-catalog-service");
/**
 * Class retrieves information about video and website's URL
 * Available data types:
 * 1. Video specific data - information about item and video urls
 * 2. Site url - where is embedded video was copied from
 * USE CASE: embedded environment only!
 * @doc PublicEmbed
 */
var PublicEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(PublicEmbed, _super);
    function PublicEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns urls to play
     * @param {string} videoId
     * @param {string} channelId
     * @param {string} instanceId
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<VideoUrls>>}
     */
    PublicEmbed.prototype.getVideoUrls = function (videoId, channelId, instanceId, requestConfig) {
        return this.get("/public/embed/play/".concat(videoId), tslib_1.__assign({ params: {
                channel_id: channelId,
                instance_id: instanceId,
            } }, requestConfig));
    };
    /**
     * Returns information about specific item in catalog
     * @param {string} videoId
     * @param {string} channelId
     * @param {string} instanceId
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<EmbedVideo>>}
     */
    PublicEmbed.prototype.getVideoInfo = function (videoId, channelId, instanceId, requestConfig) {
        return this.get("/public/embed/lists/".concat(channelId, "/items/").concat(videoId, "/info"), tslib_1.__assign({ params: {
                instance_id: instanceId,
            } }, requestConfig));
    };
    /**
     * Get site url based on instanceId
     * @param {string} instanceId
     * @param {RequestOptions} requestConfig
     * @returns {Promise<HttpResponse<PublicSiteUrl>>}
     */
    PublicEmbed.prototype.getSiteUrlByInstanceId = function (instanceId, requestConfig) {
        return this.get("/public/embed/instance/".concat(instanceId, "/info"), tslib_1.__assign({ params: {
                instance_id: instanceId,
            } }, requestConfig));
    };
    /**
     * Fetch channel for embed video,
     * does the same as PrivateChannel.fetchPublicSingleChannel, but with instanceId passed to query params
     * @param channelId
     * @param instanceId
     * @param requestConfig
     */
    PublicEmbed.prototype.getChannelInfo = function (channelId, instanceId, requestConfig) {
        return this.get("/public/embed/lists/".concat(channelId, "/info"), tslib_1.__assign({ params: {
                instance_id: instanceId,
            } }, requestConfig));
    };
    /**
     * Get list of video cards for given video in channel,
     * does the same as PublicVideoCards.getList, but with instanceId passed to query params
     * @param channelId
     * @param videoId
     * @param instanceId
     * @param requestConfig
     */
    PublicEmbed.prototype.getVideoCards = function (channelId, videoId, instanceId, requestConfig) {
        return this.get("/public/embed/lists/".concat(channelId, "/items/").concat(videoId, "/actions"), tslib_1.__assign({ params: {
                instance_id: instanceId,
            } }, requestConfig));
    };
    return PublicEmbed;
}(public_catalog_service_1.PublicCatalogService));
exports.PublicEmbed = PublicEmbed;
//# sourceMappingURL=embed.js.map